/**
 * Unified-Diffs zerlegen und auswerten (GitLab-Lieferung).
 *
 * Reine Logik ohne DB: Die Anzeige bekommt die Zeilen bereits klassifiziert,
 * damit die Oberfläche keine Diff-Syntax nachbauen muss. Auch die Statistik
 * (hinzugefügte/entfernte Zeilen) entsteht hier — einmal geprüft, überall
 * verwendet.
 */
/**
 * Zerlegt einen einheitlichen Diff in klassifizierte Zeilen.
 *
 * - Kopfzeilen (`diff --git`, `index`, `---`, `+++`, `@@ …`) tragen keine
 *   Änderung und werden nur zur Orientierung angezeigt.
 * - `\ No newline at end of file` ist Kontext, kein Kopf — es gehört zur
 *   vorherigen Zeile.
 */
export function zerlegeDiff(diff) {
    const zeilen = diff.split(/\r?\n/);
    // Das abschließende Zeilenende erzeugt eine leere Restzeile — die gehört
    // nicht zum Diff. Leere Zeilen dazwischen sind echter Kontext.
    if (zeilen.at(-1) === "")
        zeilen.pop();
    const ergebnis = [];
    for (const zeile of zeilen) {
        const text = zeile;
        if (text.startsWith("diff --git ") ||
            text.startsWith("index ") ||
            text.startsWith("--- ") ||
            text.startsWith("+++ ") ||
            text.startsWith("@@")) {
            ergebnis.push({ art: "kopf", text });
        }
        else if (text.startsWith("+")) {
            ergebnis.push({ art: "hinzugefuegt", text });
        }
        else if (text.startsWith("-")) {
            ergebnis.push({ art: "entfernt", text });
        }
        else {
            ergebnis.push({ art: "kontext", text });
        }
    }
    return ergebnis;
}
/** Zählt die tatsächlich geänderten Zeilen eines Unified-Diffs. */
export function zaehleDiffZeilen(diff) {
    let hinzugefuegt = 0;
    let entfernt = 0;
    for (const zeile of zerlegeDiff(diff)) {
        if (zeile.art === "hinzugefuegt")
            hinzugefuegt += 1;
        if (zeile.art === "entfernt")
            entfernt += 1;
    }
    return { hinzugefuegt, entfernt };
}
//# sourceMappingURL=diff.js.map